module.exports = __webpack_public_path__ + "static/media/CELO.be8f2f11.svg";